import type {RouteLocationRaw} from 'vue-router';

interface PostAuthUser {
  registration_incomplete?: boolean;
}

/**
 * Where to send a user after login / password reset.
 * Incomplete owner signups must finish /company before the dashboard.
 */
export function resolvePostAuthDestination(
  user: PostAuthUser | null | undefined,
  fallback: RouteLocationRaw = {name: 'dashboard'},
): RouteLocationRaw {
  if (user?.registration_incomplete) {
    return {name: 'company.next-step'};
  }

  return fallback;
}
